import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ShowcaseDisplayAreaEnum } from 'Constants/ShowCaseConstants';
import { showcaseEndpoint } from 'Services/Apis/clients';

export const ShowcaseMenu = createAsyncThunk(
  'showcaseMenu/Load',
  async (payload, { getState }) => {
    const state = getState();
    const { oidc } = state;
    const response = await showcaseEndpoint(oidc.user).get(
      `Showcase/ActiveByDisplayArea/${ShowcaseDisplayAreaEnum.SHOWCASE_MENU}`
    );
    return response.data;
  },
);

const initialState = {
  isLoadingShowcaseMenu: true,
  successShowcaseMenu: false,
  dataShowcaseMenu: [],
};

const ShowcaseMenuSlice = createSlice({
  name: 'showcaseMenuSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ShowcaseMenu.pending, (state) => {
        state.isLoadingShowcaseMenu = true;
        state.successShowcaseMenu = false;
      })
      .addCase(ShowcaseMenu.fulfilled, (state, { payload }) => {
        state.isLoadingShowcaseMenu = false;
        if (payload?.length > 0) {
          state.dataShowcaseMenu = payload.map((item) => ({
            title: item?.title,
            identifier: item?.identifier
          }));
          state.successShowcaseMenu = true;
        } else {
          state.dataShowcaseMenu = [];
          state.successShowcaseMenu = false;
        }
      })
      .addCase(ShowcaseMenu.rejected, (state) => {
        state.isLoadingShowcaseMenu = false;
        state.dataShowcaseMenu = [];
        state.successShowcaseMenu = false;
      })
  },
});

export default ShowcaseMenuSlice.reducer;
